import { render, staticRenderFns } from "./learn4.vue?vue&type=template&id=3d9e4190&scoped=true"
import script from "./learn4.vue?vue&type=script&lang=js"
export * from "./learn4.vue?vue&type=script&lang=js"
import style0 from "./learn4.vue?vue&type=style&index=0&id=3d9e4190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9e4190",
  null
  
)

export default component.exports